export interface ThemeColors {
  // Primary colors
  primaryColor: string;
  primaryColorRgb: string;
  primaryColorLight: string;
  primaryColorDark: string;
  onPrimaryColor: string;

  // Accent colors
  accentColor: string;
  accentColorRgb: string;
  onAccentColor: string;

  // Warn/Error colors
  warnColor: string;
  onWarnColor: string;
  errorColor: string;
  onErrorColor: string;

  // Surface/Background colors
  backgroundColor: string;
  surfaceColor: string;
  headerBackgroundColor: string;
  onBackgroundColor: string;
  onSurfaceColor: string;
  onSurfaceVariantColor: string;
}

export const THEME_COLORS: Record<string, { light: ThemeColors; dark: ThemeColors }> = {
  'deeppurple-amber': {
    light: {
      primaryColor: '#673ab7',
      primaryColorRgb: '103, 58, 183',
      primaryColorLight: '#9575cd',
      primaryColorDark: '#512da8',
      onPrimaryColor: '#ffffff',

      accentColor: '#ff6f00',
      accentColorRgb: '255, 111, 0',
      onAccentColor: '#ffffff',

      warnColor: '#d32f2f',
      onWarnColor: '#ffffff',
      errorColor: '#d32f2f',
      onErrorColor: '#ffffff',

      backgroundColor: '#f5f5f5',
      surfaceColor: '#ffffff',
      headerBackgroundColor: '#ede7f6',
      onBackgroundColor: '#212121',
      onSurfaceColor: '#212121',
      onSurfaceVariantColor: '#49454f',
    },
    dark: {
      primaryColor: '#b39ddb',
      primaryColorRgb: '179, 157, 219',
      primaryColorLight: '#e1bee7',
      primaryColorDark: '#9575cd',
      onPrimaryColor: '#ffffff',

      accentColor: '#ffb74d',
      accentColorRgb: '255, 183, 77',
      onAccentColor: '#1a1a1a',

      warnColor: '#ef5350',
      onWarnColor: '#ffffff',
      errorColor: '#ef5350',
      onErrorColor: '#ffffff',

      backgroundColor: '#212121',
      surfaceColor: '#3a3a3a',
      headerBackgroundColor: '#7b1fa2',
      onBackgroundColor: '#f5f5f5',
      onSurfaceColor: '#f5f5f5',
      onSurfaceVariantColor: '#e0e0e0',
    },
  },
  'purple-green': {
    light: {
      primaryColor: '#7b1fa2',
      primaryColorRgb: '123, 31, 162',
      primaryColorLight: '#9c27b0',
      primaryColorDark: '#6a1b9a',
      onPrimaryColor: '#ffffff',

      accentColor: '#00c853',
      accentColorRgb: '0, 200, 83',
      onAccentColor: '#ffffff',

      warnColor: '#d32f2f',
      onWarnColor: '#ffffff',
      errorColor: '#d32f2f',
      onErrorColor: '#ffffff',

      backgroundColor: '#fafafa',
      surfaceColor: '#ffffff',
      headerBackgroundColor: '#f3e5f5',
      onBackgroundColor: '#1a1a1a',
      onSurfaceColor: '#1a1a1a',
      onSurfaceVariantColor: '#404040',
    },
    dark: {
      primaryColor: '#ce93d8',
      primaryColorRgb: '206, 147, 216',
      primaryColorLight: '#f3e5f5',
      primaryColorDark: '#ab47bc',
      onPrimaryColor: '#1a1a1a',

      accentColor: '#69f0ae',
      accentColorRgb: '105, 240, 174',
      onAccentColor: '#1a1a1a',

      warnColor: '#ef5350',
      onWarnColor: '#ffffff',
      errorColor: '#ef5350',
      onErrorColor: '#ffffff',

      backgroundColor: '#1a1a1a',
      surfaceColor: '#2d2d2d',
      headerBackgroundColor: '#8e24aa',
      onBackgroundColor: '#d9d9d9',
      onSurfaceColor: '#d9d9d9',
      onSurfaceVariantColor: '#a6a6a6',
    },
  },
  'azure-blue': {
    light: {
      primaryColor: '#4c8bf5',
      primaryColorRgb: '76, 139, 245',
      primaryColorLight: '#a0c4ff',
      primaryColorDark: '#005cbb',
      onPrimaryColor: '#ffffff',

      accentColor: '#ff9800',
      accentColorRgb: '255, 152, 0',
      onAccentColor: '#ffffff',

      warnColor: '#ba1a1a',
      onWarnColor: '#ffffff',
      errorColor: '#ba1a1a',
      onErrorColor: '#ffffff',

      backgroundColor: '#f5f5f5',
      surfaceColor: '#ffffff',
      headerBackgroundColor: '#dae2f9',
      onBackgroundColor: '#212121',
      onSurfaceColor: '#212121',
      onSurfaceVariantColor: '#49454f',
    },
    dark: {
      primaryColor: '#4c8bf5',
      primaryColorRgb: '76, 139, 245',
      primaryColorLight: '#a0c4ff',
      primaryColorDark: '#005cbb',
      onPrimaryColor: '#ffffff',

      accentColor: '#ffb74d',
      accentColorRgb: '255, 183, 77',
      onAccentColor: '#1a1a1a',

      warnColor: '#ef5350',
      onWarnColor: '#ffffff',
      errorColor: '#ef5350',
      onErrorColor: '#ffffff',

      backgroundColor: '#212121',
      surfaceColor: '#3a3a3a',
      headerBackgroundColor: '#1976d2',
      onBackgroundColor: '#f5f5f5',
      onSurfaceColor: '#f5f5f5',
      onSurfaceVariantColor: '#e0e0e0',
    },
  },
  'black-white': {
    light: {
      primaryColor: '#000000',
      primaryColorRgb: '0, 0, 0',
      primaryColorLight: '#595959',
      primaryColorDark: '#1a1a1a',
      onPrimaryColor: '#ffffff',

      accentColor: '#666666',
      accentColorRgb: '102, 102, 102',
      onAccentColor: '#ffffff',

      warnColor: '#ba1a1a',
      onWarnColor: '#ffffff',
      errorColor: '#ba1a1a',
      onErrorColor: '#ffffff',

      backgroundColor: '#fafafa',
      surfaceColor: '#ffffff',
      headerBackgroundColor: '#000000',
      onBackgroundColor: '#1a1a1a',
      onSurfaceColor: '#1a1a1a',
      onSurfaceVariantColor: '#404040',
    },
    dark: {
      primaryColor: '#d9d9d9',
      primaryColorRgb: '217, 217, 217',
      primaryColorLight: '#ededed',
      primaryColorDark: '#bfbfbf',
      onPrimaryColor: '#1a1a1a',

      accentColor: '#999999',
      accentColorRgb: '153, 153, 153',
      onAccentColor: '#1a1a1a',

      warnColor: '#ef5350',
      onWarnColor: '#ffffff',
      errorColor: '#ef5350',
      onErrorColor: '#ffffff',

      backgroundColor: '#1a1a1a',
      surfaceColor: '#2d2d2d',
      headerBackgroundColor: '#2d2d2d',
      onBackgroundColor: '#d9d9d9',
      onSurfaceColor: '#d9d9d9',
      onSurfaceVariantColor: '#a6a6a6',
    },
  },
};
